const recurringInput = {
  frequency: {
    title: 'הגדר כיצד משמרת זו חוזרת לאורך זמן',
    values: {
      dontRepeat: 'לא חוזר',
      day: 'יומי',
      week: 'שבועי',
      month: 'חודשי',
    },
    labels: {
      day: 'ימים',
      week: 'שבועות',
      month: 'חודשים',
    },
  },
  repeatEvery: 'חזור כל',
  repeatOn: 'חזור ב',
  repeatOnNote: 'יש לבחור לפחות יום אחד',
  ends: 'מסתיים',
  endsOn: 'מסתיים ב',
  endsLabels: {
    never: 'לעולם לא מסתיים',
    date: `עד {{date}}`,
    times: 'לאחר {{number}} מופעים',
  },
  windowNote: 'כעת ייווצרו רק {{count}} המשמרות הראשונות. השאר ייווצרו אוטומטית על ידי תהליך רקע עם הזמן.',
  endsDateNote: 'תאריך הסיום שנבחר מוקדם מדי - לא ייווצרו משמרות. בחר תאריך מאוחר יותר.',

  form: {
    month: 'חודש',
    day: 'יום',
    week: 'שבוע',
    year: 'שנה',
    occurrences: 'התרחשויות',
    after: 'לאחר',
    never: 'לעולם לא',
    on: 'בתאריך',
  },
};

export default recurringInput;
